import { Button, Typography, styled, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { useState } from "react";

const ConnectButtonStyle = styled(Button)`
  border-radius: 6px !important;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 24px;
  padding: 0 12px !important;

  .MuiButton-startIcon {
    margin-right: 6px;
    margin-left: 0;
  }
`;

const ConnectButton = ({ img, onConnect, connectOptions }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    if (connectOptions && connectOptions.length > 0) {
      setAnchorEl(e.currentTarget);
    } else {
      onConnect();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ConnectButtonStyle
        onClick={handleClick}
        startIcon={<img src={img} alt="" width={16} height={16} />}
        endIcon={connectOptions && connectOptions.length > 0 ? <span className="material-symbols-rounded" style={{ fontSize: "16px" }}>arrow_drop_down</span> : null}
      >
        <Typography variant="caption" color="white">
          Connect
        </Typography>
      </ConnectButtonStyle>

      {connectOptions && connectOptions.length > 0 && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{
            style: {
              background: "#00162A",
              border: "1px solid rgba(255,255,255,0.2)",
              color: "white"
            }
          }}
        >
          {connectOptions.map((opt, i) => (
            <MenuItem key={i} onClick={() => { handleClose(); opt.onClick(); }}>
              <ListItemIcon sx={{ minWidth: "30px !important" }}>
                <img src={opt.img} alt="" width={20} height={20} />
              </ListItemIcon>
              <ListItemText><Typography variant="body2">{opt.name}</Typography></ListItemText>
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default ConnectButton;
